<video playsinline autoplay muted loop poster="polina.jpg" id="bgvid">
 
    <source src="../../assets/pexels-mikhail-nilov-6981339.mp4" type="video/mp4">
    <audio autoplay loop src="./../../assets/beachbg.mp3"></audio>
  </video>
<!-- Credits: Video by Mikhail Nilov from Pexels -->

  <!-- <header class="viewport-header">
    <h1>
     Calm
      <span>Room</span>
    </h1>
  </header> -->